import { Injectable } from '@angular/core';
import {LoadingController} from "ionic-angular/index";
import {global} from "../../environments/global";

/*
  Generated class for the CustomLoadingProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CustomLoadingProvider {

  public showingLoading: boolean = false;

  constructor(public loadingCtrl:LoadingController) {
    console.log('Hello CustomLoadingProvider Provider');

  }

  loading;

  public showLoader(){

    if(!document.getElementById('loading') || document.getElementById('loading').classList.contains('hide')){
      this.loading = this.loadingCtrl.create({
        spinner:'hide',
        content:'<div class="o-csloader-container"> <div class="loading-coin font-gray"> <img src="./assets/imgs/'+ global.app_name +'/loading.gif"><br><br>正在努力加载中 </div></div>'
      });
      this.loading.present();
      // console.log(this.loading);
      this.showingLoading = true;
    }
  }

  public dismissLoader(){
    // document.getElementById('loading').classList.add('hide');
    this.loading.dismiss();
    // console.log(this.loading);
    this.showingLoading = false;
    try {
      // this.loading.dismiss();
      if(document.getElementById('loading'))
        document.getElementById('loading').remove();
    }
    catch (e){
      // console.log(e);
    }

  }

}



// WEBPACK FOOTER //
// ./src/providers/custom-loading/custom-loading.ts